import { Injectable } from '@angular/core';
import { BaseService, E8HttpClient, C8HttpClientOptions } from '../../../../core';
import { DynamicComponentDetailFormGetMetaInfoRequest } from './model/dynamicComponentDetailFormGetMetaInfoRequest';
import { DynamicComponentDetailFormGetMetaInfoResponse } from './model/dynamicComponentDetailFormGetMetaInfoResponse';
import { DynamicComponentDetailFormGetModelRequest } from './model/dynamicComponentDetailFormGetModelRequest';
import { DynamicComponentDetailFormGetModelResponse } from './model/dynamicComponentDetailFormGetModelResponse';

@Injectable()
export class DynamicComponentDetailFormService extends BaseService {
  private getColsMetaInfo_URL = 'metabase/dynamicComponentDetailForm/getMetaInfo';
  private getModel_URL = 'metabase/dynamicComponentDetailForm/getModel';
  constructor(private client: E8HttpClient) {
    super();
  }
  getMetaInfo(request: DynamicComponentDetailFormGetMetaInfoRequest, options?: C8HttpClientOptions): Promise<DynamicComponentDetailFormGetMetaInfoResponse> {
    return this.client.post(this.fUrl(this.getColsMetaInfo_URL), request, options);
  }
  getModel(request: DynamicComponentDetailFormGetModelRequest, options?: C8HttpClientOptions): Promise<DynamicComponentDetailFormGetModelResponse> {
    return this.client.post(this.fUrl(this.getModel_URL), request, options);
  }
}
